import React from 'react';
import PropTypes from 'prop-types';

import { Container, Content, Image } from '../BloodFront/styles';
import {
  Head,
  LeftElbow,
  RightElbow,
  LeftButtock,
  RightButtock,
  LeftCalf,
  RightCalf,
  LeftAnkle,
  RightAnkle,
} from './styles';

import back from '~/assets/back-person-hdpi.png';

export default function BloodBack({ region, decrease }) {
  return (
    <Container>
      <Content decrease={decrease}>
        <Image src={back} alt="Região posterior" />

        {/* Cabeça */}
        <Head decrease={decrease} active={region === `atrás da cabeça`} />

        {/* Cotovelo esquerdo */}
        <LeftElbow
          decrease={decrease}
          active={region === `cotovelo esquerdo`}
        />

        {/* Cotovelo direito */}
        <RightElbow
          decrease={decrease}
          active={region === `cotovelo direito`}
        />

        {/* Nádega esquerda */}
        <LeftButtock
          decrease={decrease}
          active={region === `nádega esquerda`}
        />

        {/* Nádega direita */}
        <RightButtock
          decrease={decrease}
          active={region === `nádega direita`}
        />

        {/* Panturrilha esquerda */}
        <LeftCalf
          decrease={decrease}
          active={region === `panturrilha esquerda`}
        />

        {/* Panturrilha direita */}
        <RightCalf
          decrease={decrease}
          active={region === `panturrilha direita`}
        />

        {/* Tornozelo esquerdo */}
        <LeftAnkle
          decrease={decrease}
          active={region === `tornozelo esquerdo`}
        />

        {/* Tornozelo direito */}
        <RightAnkle
          decrease={decrease}
          active={region === `tornozelo direito`}
        />
      </Content>
    </Container>
  );
}

BloodBack.propTypes = {
  region: PropTypes.string,
  decrease: PropTypes.bool,
};

BloodBack.defaultProps = {
  region: null,
  decrease: true,
};
